const PAYMENT_PARAMETER_NAME = 'status';
const STATUS_SUCCESS = 'success';
const STATUS_FAIL = 'error';

export default {
    methods: {
        getFailUrl() {
            let url = new URL(window.location.href);
            if (url.searchParams.has(PAYMENT_PARAMETER_NAME)) {
                url.searchParams.set(PAYMENT_PARAMETER_NAME, STATUS_FAIL);
            } else {
                url.searchParams.append(PAYMENT_PARAMETER_NAME, STATUS_FAIL);
            }

            return url.toString();
        },

        getSuccessUrl() {
            let url = new URL(window.location.href);
            if (url.searchParams.has(PAYMENT_PARAMETER_NAME)) {
                url.searchParams.set(PAYMENT_PARAMETER_NAME, STATUS_SUCCESS);
            } else {
                url.searchParams.append(PAYMENT_PARAMETER_NAME, STATUS_SUCCESS);
            }

            return url.toString();
        },

        isFailUrl() {
            return this.getUrlParameter(PAYMENT_PARAMETER_NAME) === STATUS_FAIL;
        },

        isSuccessUrl() {
            return this.getUrlParameter(PAYMENT_PARAMETER_NAME) === STATUS_SUCCESS;
        },

        getUrlParameter(name) {
            const currentUrl = new URL(window.location.href);
            return currentUrl.searchParams.get(name);
        }
    }
}
